import { createRoot } from 'react-dom/client';
import '@fontsource/chakra-petch/500.css';
import '@fontsource/chakra-petch/600.css';
import '@fontsource/chakra-petch/700.css';
import '@fontsource/ibm-plex-sans/400.css';
import '@fontsource/ibm-plex-sans/500.css';
import '@fontsource/ibm-plex-sans/600.css';
import '@fontsource/jetbrains-mono/400.css';
import '@fontsource/jetbrains-mono/600.css';
import './design/tokens.css';
import './design/bundle.css';
import './app.css';
import { App } from './App';

createRoot(document.getElementById('root')!).render(<App />);
if ('serviceWorker' in navigator) navigator.serviceWorker.register('/sw.js').catch(() => {});

// A home-screen app on iPhone stays in memory for days: when a new build is on the server, reload.
declare const __BUILD__: string;
async function checkVersion() {
  try {
    const r = await fetch('/version.json', { cache: 'no-store' });
    const { build } = await r.json();
    if (build && build !== __BUILD__) location.reload();
  } catch { /* offline */ }
}
document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') checkVersion(); });
setInterval(checkVersion, 60_000);
